export const discover = {
  title: "さがす",
  available: "利用可能",
  coins: "コイン",
  list: {
    empty: "ユーザーが見つかりませんでした",
  },
  recentVideoCallSection: {
    title: "今すぐビデオ通話できる女の子",
    empty: "今すぐ通話できる女の子はいません。",
    minutesAgoCall: (args: { count: string | number }) =>
      `${args.count}分前に通話`,
    hoursAgoCall: (args: { count: string | number }) =>
      `${args.count}時間前に通話`,
    callButton: "発信",
  },
  highReviewScoreSection: {
    title: "評価が高い女の子",
    empty: "評価が高い女の子はいません。",
  },
  preferenceMatchSection: {
    title: "あなたの好みに合う子",
    empty: "好みの条件に合う女の子が見つかりませんでした。",
  },
  sakura: {
    tabs: {
      newcomer: "最近はじめた女の子",
      recommended: "おすすめ",
      highRated: "高評価",
      preferenceMatch: "好みに合う子",
    },
    instantCallTitle: "すぐ通話ができる女の子",
    highReviewTitle: "評価が高いユーザー",
    rankingTitle: "ビデオ通話ランキング",
    preferenceMatchTitle: "あなたの好みに合う子",
    browseTitle: "女の子をさがす",
    callButton: "通話",
    instantCallButton: "発信",
    reviewCount: (args: { count: string | number }) => `（${args.count}件）`,
    reviewCountShort: (args: { count: string | number }) => `(${args.count})`,
  },
} as const;
